<template>
  <!-- 休假申请 -->
  <div>
    <Collapse v-model="value" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.BasicInformation : enName.BasicInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :disabled="isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.createTime : enName.createTime"
              >
                <Input disabled v-model="formItem.createTime" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.applyNo : enName.applyNo">
                <Input disabled v-model="formItem.applyNo" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyName : enName.applyName"
              >
                <Input disabled v-model="formItem.applyName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyUserId : enName.applyUserId"
              >
                <Input disabled v-model="formItem.applyUserId" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.applyPosition : enName.applyPosition
                "
              >
                <Input disabled v-model="formItem.applyPosition" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.LeaveApplicationInformation
              : enName.LeaveApplicationInformation
          "
        />
        <Form
          slot="content"
          :model="formItem"
          ref="formItem"
          v-model="formItem"
          :rules="ruleValidate"
          :label-width="165"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :disabled="isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="10" :xl="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvType : enName.lvType"
                prop="lvType"
              >
                <Select
                  v-model="formItem.lvType"
                  :clearable="true"
                  placeholder=""
                  @on-change="lvTypeChange"
                >
                  <Option
                    :value="item.lvType"
                    v-for="(item, i) in LEAVETYPE"
                    :key="i"
                    >{{ item.lvPolicyNm }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvBeginDt : enName.lvBeginDt"
                prop="lvBeginDt"
              >
                <DatePicker
                  @on-change="BeginDateChange"
                  v-model="formItem.lvBeginDt"
                  style="width:100%"
                  :editable="false"
                  :options="options1"
                  type="date"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="3">
              <FormItem
                label=""
                prop="lvBeginTm"
                :label-width="20"
                v-if="unit == 'H' || unit == null"
              >
                <TimePicker
                  v-model="formItem.lvBeginTm"
                  style="margin-left:20px"
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                ></TimePicker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.lvEndDt : enName.lvEndDt"
                prop="lvEndDt"
              >
                <DatePicker
                  @on-change="EndDateChange"
                  v-model="formItem.lvEndDt"
                  style="width:100%"
                  :options="options1"
                  :disabled="formItem.lvType == 'M' || formItem.lvType == 'TP'"
                  type="date"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="12" :sm="12" :md="12" :lg="12" :xl="3">
              <FormItem
                label=""
                prop="lvEndTm"
                :label-width="20"
                v-if="unit == 'H' || unit == null"
              >
                <TimePicker
                  v-model="formItem.lvEndTm"
                  style="margin-left:20px"
                  :disabled="beEndDt"
                  format="HH:mm"
                  :steps="[1, 30]"
                ></TimePicker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="start" v-if="unit == 'D' || unit == null">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.lvDays : enName.lvDays">
                <Input disabled v-model="formItem.lvDays" />
              </FormItem>
            </Col>
            <Col offset="1">
              <Button @click="getlvTimes" v-show="!isHistory">{{
                lang == "zh"
                  ? chName.calculateTheLengthOfLeaveTime
                  : enName.calculateTheLengthOfLeaveTime
              }}</Button>
            </Col>
          </Row>

          <Row type="flex" justify="start" v-if="unit == 'H'">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.lvHours : enName.lvHours">
                <Input disabled v-model="formItem.lvHours" />
              </FormItem>
            </Col>
            <Col offset="1">
              <Button @click="getlvTimes" v-show="!isHistory">{{
                lang == "zh"
                  ? chName.calculateTheLengthOfLeaveTime
                  : enName.calculateTheLengthOfLeaveTime
              }}</Button>
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="7"
              v-if="formItem.lvType == '3' || formItem.lvType == '0'"
            >
              <FormItem
                :label="
                  lang == 'zh' ? chName.Holiday_Ealance : enName.Holiday_Ealance
                "
              >
                <Input disabled v-model="HolidayEalance" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem
                span="3"
                :label="lang == 'zh' ? chName.reason : enName.reason"
                prop="reason"
              >
                <Input type="textarea" v-model="formItem.reason" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between" v-show="allowAttcheNull">
            <Col span="18">
              <FormItem
                :label="
                  lang == 'zh' ? chName.file_attachment : enName.file_attachment
                "
                style="margin-top:15px"
              >
                <j2-FileUP
                  ref="file1"
                  @handleDel="fileDel"
                  @handleOK="fileSuc"
                  :disabled="isHistory"
                  :file_type="{ resourceType: 'LeaveApplication_Attachment' }"
                  :resourceId="formItem.file_attachment"
                ></j2-FileUP>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <!-- 审批历史 -->
      <Panel
        name="5"
        hide-arrow
        style="margin-bottom: 20px; border: 0"
        v-if="isHistory"
      >
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
          "
        />
        <Table
          border
          :columns="columns3"
          :data="data3"
          slot="content"
          style="margin: 30px 30px 0 30px"
        >
        </Table>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" v-if="!isHistory" @click="importCG">{{
          lang == "zh" ? chName.importDraft : enName.importDraft
        }}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG">{{
          lang == "zh" ? chName.savetDraft : enName.savetDraft
        }}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{
          lang == "zh" ? chName.submit : enName.submit
        }}</Button>
        <Button class="applyBtnRight" @click="returnPage">{{
          lang == "zh" ? chName.return : enName.return
        }}</Button>
      </Col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    const checklvBeginDt = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择休假开始时间"));
      } else {
        if (
          this.formItem.lvEndDt &&
          this.formItem.lvBeginTm &&
          this.formItem.lvEndTm
        ) {
          let datetime1 = this.date.dateVal(value, "YYYY-MM-DD");
          let datetime2 = this.date.dateVal(
            this.formItem.lvEndDt,
            "YYYY-MM-DD"
          );
          if (datetime1 <= datetime2) {
            callback();
          } else {
            callback(new Error("休假开始时间不得大于休假结束时间！"));
          }
        } else {
          callback();
        }
      }
    };
    const checklvEndDt = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择休假结束时间"));
      } else {
        if (
          this.formItem.lvBeginDt &&
          this.formItem.lvBeginTm &&
          this.formItem.lvEndTm
        ) {
          let datetime1 = this.date.dateVal(
            this.formItem.lvBeginDt,
            "YYYY-MM-DD"
          );
          let datetime2 = this.date.dateVal(value, "YYYY-MM-DD");
          if (datetime1 <= datetime2) {
            callback();
          } else {
            callback(new Error("休假结束时间不得小于休假开始时间！"));
          }
        } else {
          callback();
        }
      }
    };
    const checklvBeginTm = (rule, value, callback) => {
      if (!value) {
        callback("请选择时间");
      } else {
        let datetime1 = new Date(this.formItem.lvBeginDt),
          datetime2 = new Date(this.formItem.lvEndDt);
        if (
          datetime1 &&
          datetime2 &&
          this.formItem.lvBeginTm &&
          this.formItem.lvEndTm
        ) {
          datetime1.setHours(
            this.formItem.lvBeginTm.split(":")[0],
            this.formItem.lvBeginTm.split(":")[1],
            0
          );
          datetime2.setHours(
            this.formItem.lvEndTm.split(":")[0],
            this.formItem.lvEndTm.split(":")[1],
            0
          );
          if (datetime1 <= datetime2) {
            datetime1 = null;
            datetime2 = null;
            callback();
          } else {
            datetime1 = null;
            datetime2 = null;
            callback(new Error("休假开始时间不得大于休假结束时间！"));
          }
        } else {
          callback();
        }
      }
    };
    const checklvEndTm = (rule, value, callback) => {
      if (!value) {
        callback("请选择时间");
      } else {
        let datetime1 = new Date(this.formItem.lvBeginDt),
          datetime2 = new Date(this.formItem.lvEndDt);
        if (
          datetime1 &&
          datetime2 &&
          this.formItem.lvBeginTm &&
          this.formItem.lvEndTm
        ) {
          datetime1.setHours(
            this.formItem.lvBeginTm.split(":")[0],
            this.formItem.lvBeginTm.split(":")[1],
            0
          );
          datetime2.setHours(
            this.formItem.lvEndTm.split(":")[0],
            this.formItem.lvEndTm.split(":")[1],
            0
          );
          if (datetime1 <= datetime2) {
            datetime1 = null;
            datetime2 = null;
            callback();
          } else {
            datetime1 = null;
            datetime2 = null;
            callback(new Error("休假结束时间不得小于休假开始时间！"));
          }
        } else {
          callback();
        }
      }
    };
    return {
      ruleValidate: {
        lvType: [{ required: true, message: "请选择休假类型" }],
        lvBeginDt: [
          { required: true, message: "请选择休假开始日期" },
          { required: true, validator: checklvBeginDt }
        ],
        lvBeginTm: [
          { required: true, message: "请选择休假开始时间" },
          { required: true, validator: checklvBeginTm }
        ],
        lvEndDt: [
          { required: true, message: "请选择休假结束日期" },
          { required: true, validator: checklvEndDt }
        ],
        lvEndTm: [
          { required: true, message: "请选择休假结束时间" },
          { required: true, validator: checklvEndTm }
        ],
        reason: [{ required: true, message: "请输入休假事由" }]
        // comments: [{ required: true,message: '请输入备注'}],
      },
      options1: {
        disabledDate(date) {
          // return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      date: new DateUtil(),
      value: [1, 4, 5],
      formItem: {
        applyUserId: "",
        createTime: "",
        lvBeginDt: "",
        lvBeginTm: "",
        lvDays: "",
        lvEndDt: "",
        lvEndTm: "",
        lvHours: "",
        reason: ""
      },
      HolidayEalance: "",
      data3: [],
      isHistory: false,
      spinShow: false,
      chName: {},
      enName: {},
      LEAVETYPE: [],
      DECEASED: [],
      PUBLICERRANDLEAVE: [],
      TRANSFERLEAVE: [],
      attachmentList: [],
      lvType: null,
      unit: null,
      resourceId_List: [],
      allowAttcheNull: false,
      beEndDt: false
    };
  },
  created() {
    // 查询国际化
    this.getInternation();
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
      this.getHistoryData();
    } else {
      this.getPerson();
    }
  },
  watch: {
    "formItem.lvBeginDt"(val) {
      if (this.formItem.lvEndDt != "") {
        this.$refs["formItem"].fields.forEach(e => {
          if (e._props.prop == "lvEndDt") {
            e.validate();
          }
        });
      }
    },
    "formItem.lvEndDt"(val) {
      if (this.formItem.lvBeginDt != "") {
        this.$refs["formItem"].fields.forEach(e => {
          if (e._props.prop == "lvBeginDt") {
            e.validate();
          }
        });
      }
    }
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns3() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    }
  },
  methods: {
    getHolidayEalance() {
      let obj = {
        empCode: this.formItem.applyUserId,
        lvType: this.formItem.lvType
      };
      axios.post("/applyLeave/getHolidayBalance", obj).then(res => {
        this.HolidayEalance = res.HolidayEalance;
      });
    },
    getInternation() {
      let Obj = {
        viewType: "Leave_Apply",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    // 上传附件
    fileSuc(res_id) {
      this.formItem.file_attachment = res_id;
    },
    fileDel(res_id) {
      this.formItem.file_attachment = "";
      this.resourceId_List.push(res_id);
    },
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "LV01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      this.formItem.lvBeginDt = this.formItem.lvBeginDt
        ? this.date.dateVal(this.formItem.lvBeginDt, "YYYY-MM-DD")
        : null;
      this.formItem.lvEndDt = this.formItem.lvEndDt
        ? this.date.dateVal(this.formItem.lvEndDt, "YYYY-MM-DD")
        : null;
      if (this.$refs.file1 && this.$refs.file1.fileName != null) {
        this.formItem.file_attachment = this.$refs.file1.resource_id;
        this.formItem.file_attachment_name = this.$refs.file1.fileName;
      }
      //草稿type 草稿内容
      this.$refs.cgPop.popShow("LV01", {
        formItem: this.formItem,
        lvType: this.lvType
      });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      var str = JSON.parse(row.draftContent);
      this.formItem = str.formItem;
      this.lvType = str.lvType;
      this.getPerson();
      this.getlvTypeChange();
      if (
        this.formItem.file_attachment &&
        this.formItem.file_attachment != null
      ) {
        this.$refs.file1.resource_id = this.formItem.file_attachment;
        this.$refs.file1.fileName = this.formItem.file_attachment_name;
      }
    },
    getHistoryData() {
      this.spinShow = true;
      let obj = { instanceId: this.getQueryVariable("instanceId") };
      axios.post("applyLeave/selectApplyLeave", obj).then(res => {
        if (res) {
          this.formItem = res.applyLeave;
          this.$refs.file1.resource_id = this.formItem.fileAttachment
            ? this.formItem.fileAttachment
            : null;
          this.$refs.file1.fileName = this.formItem.fileAttachmentName
            ? this.formItem.fileAttachmentName
            : null;
          this.formItem.createTime = this.date.dateVal(
            this.formItem.createTime,
            "YYYY-MM-DD"
          );
          this.formItem.lvBeginTm = this.date.dateVal(
            this.formItem.lvBeginTm,
            "HH:mm"
          );
          this.formItem.lvEndTm = this.date.dateVal(
            this.formItem.lvEndTm,
            "HH:mm"
          );
          this.lvType = this.formItem.lvType;
          this.data3 = res.logMap;
          let obj2 = {
            serialnumber: res.applyLeave.applySerialnumber
          };
          axios.post("empInfo/employeeSearch", obj2).then(res2 => {
            if (res2) {
              this.$set(this.formItem, "genderCode", res2[0].genderCode);
              this.$set(this.formItem, "maritalCode", res2[0].maritalCode);
              this.$set(this.formItem, "hrstatus", res2[0].hrstatus);
              let obj1 = {
                matchSex: this.formItem.genderCode,
                matchMarried: this.formItem.maritalCode,
                matchEmpType: this.formItem.hrstatus,
                allowShiyongqi: this.formItem.inProbation
              };
              axios.post("/lvCode/searchLeaveType", obj1).then(res1 => {
                if (res1) {
                  this.LEAVETYPE = res1;
                  this.LEAVETYPE.forEach(item => {
                    if (item.lvType == this.formItem.lvType) {
                      this.unit = item.unit;
                      this.allowAttcheNull =
                        item.allowAttcheNull == 1
                          ? true
                          : item.allowAttcheNull == 0
                          ? false
                          : null;
                    }
                  });
                  console.log(
                    this.formItem.lvType,
                    "unit:" + this.unit,
                    "allowAttcheNull:" + this.allowAttcheNull
                  );
                }
                this.spinShow = false;
              });
            } else {
              this.spinShow = false;
            }
          });
          axios.post("applyLeave/LeaveCheckBox", {}).then(res3 => {
            if (res3) {
              this.DECEASED = res3.DECEASED;
              this.PUBLICERRANDLEAVE = res3.PUBLICERRANDLEAVE;
              this.TRANSFERLEAVE = res3.TRANSFERLEAVE;
            } else {
              this.spinShow = false;
            }
          });
        } else {
          this.spinShow = false;
        }
      });
    },
    getPerson() {
      var Obj = {};
      Obj = JSON.parse(sessionStorage.getItem("userInfo"));
      this.$set(this.formItem, "applyUserId", Obj.userId);
      this.$set(
        this.formItem,
        "createTime",
        this.date.dateVal(new Date(), "YYYY-MM-DD")
      );
      let obj = {
        serialnumber: Obj.serialnumber
      };
      axios.post("empInfo/employeeSearch", obj).then(res => {
        if (res) {
          this.$set(this.formItem, "applyName", res[0].userName);
          this.$set(this.formItem, "applyPosition", res[0].positionName);
          this.$set(this.formItem, "genderCode", res[0].genderCode);
          this.$set(this.formItem, "maritalCode", res[0].maritalCode);
          this.$set(this.formItem, "hrstatus", res[0].hrstatus);
          let obj1 = {
            matchSex: this.formItem.genderCode,
            matchMarried: this.formItem.maritalCode,
            matchEmpType: this.formItem.hrstatus,
            allowShiyongqi: this.formItem.inProbation
          };
          axios.post("/lvCode/searchLeaveType", obj1).then(res1 => {
            if (res1) {
              this.LEAVETYPE = res1;
            }
          });
        }
      });
      axios.post("applyLeave/LeaveCheckBox", {}).then(res => {
        if (res) {
          this.DECEASED = res.DECEASED;
          this.PUBLICERRANDLEAVE = res.PUBLICERRANDLEAVE;
          this.TRANSFERLEAVE = res.TRANSFERLEAVE;
        }
      });
    },
    // 手动改变休假类型
    lvTypeChange(val) {
      this.lvType = val;
      this.getlvTypeChange();
      this.$refs["formItem"].fields.forEach(e => {
        if (e._props.prop) {
          e.resetField();
        }
      });
      this.formItem.lvType = this.lvType;
      this.formItem.lvDays = "";
      this.formItem.lvHours = "";
      this.formItem.file_attachment = "";
      this.formItem.file_attachment_name = "";
      this.$refs.file1.resource_id = "";
      this.$refs.file1.fileName = "";
      this.getDateChange();
    },
    getlvTypeChange() {
      let obj = {
        lvType: this.lvType
      };
      axios
        .post("applyLeave/attachedSupportingDocumentsCheckBox", obj)
        .then(res => {
          if (res) {
            this.formItem.lvType = this.lvType;
            this.LEAVETYPE.forEach(item => {
              if (item.lvType == this.formItem.lvType) {
                this.unit = item.unit;
                this.allowAttcheNull =
                  item.allowAttcheNull == 1
                    ? true
                    : item.allowAttcheNull == 0
                    ? false
                    : null;
              }
            });
            console.log(
              this.formItem.lvType,
              "unit:" + this.unit,
              "allowAttcheNull:" + this.allowAttcheNull
            );
          }
        });
    },
    getlvTimes() {
      if (
        this.formItem.lvType &&
        this.formItem.lvBeginDt &&
        this.formItem.lvBeginTm &&
        this.formItem.lvEndDt &&
        this.formItem.lvEndTm
      ) {
        this.formItem.lvBeginDt = this.formItem.lvBeginDt
          ? this.date.dateVal(this.formItem.lvBeginDt, "YYYY-MM-DD")
          : null;
        this.formItem.lvEndDt = this.formItem.lvEndDt
          ? this.date.dateVal(this.formItem.lvEndDt, "YYYY-MM-DD")
          : null;
        let obj = {
          lvType: this.formItem.lvType,
          lvBeginDt: this.formItem.lvBeginDt,
          lvEndDt: this.formItem.lvEndDt,
          lvBeginTm: new Date(
            this.formItem.lvBeginDt + " " + this.formItem.lvBeginTm
          ),
          lvEndTm: new Date(
            this.formItem.lvEndDt + " " + this.formItem.lvEndTm
          ),
          applySerialnumber: JSON.parse(
            window.sessionStorage.getItem("userInfo")
          ).serialnumber
        };
        axios.post("/applyLeave/calculationLeaveTime", obj).then(res => {
          this.formItem.lvDays = res.lvDays;
          this.formItem.lvHours = res.lvHours;
        });
      }
    },
    BeginDateChange() {
      if (this.formItem.lvType && this.formItem.lvBeginDt) {
        this.$set(this.formItem, "lvBeginTm", "08:30");
        this.formItem.lvType == "M"
          ? this.$set(
              this.formItem,
              "lvEndDt",
              this.getNextDate(this.formItem.lvBeginDt, 9)
            )
          : "";
        this.formItem.lvType == "TP"
          ? this.$set(
              this.formItem,
              "lvEndDt",
              this.getNextDate(this.formItem.lvBeginDt, 14)
            )
          : "";
        // 青年节假，妇女节假
        if (this.formItem.lvType == "P01" || this.formItem.lvType == "P02") {
          this.$set(this.formItem, "lvEndDt", this.formItem.lvBeginDt);
          this.$set(this.formItem, "lvEndTm", "12:30");
        }
        this.LEAVETYPE.forEach(item => {
          if (item.lvType == this.formItem.lvType && item.bePostpone != null) {
            let obj = {
              lvBeginDt: this.date.dateVal(
                this.formItem.lvBeginDt,
                "YYYY-MM-DD"
              ),
              lvType: this.formItem.lvType,
              applySerialnumber: JSON.parse(
                window.sessionStorage.getItem("userInfo")
              ).serialnumber
            };
            axios.post("/applyLeave/getLeaveEndDt", obj).then(res => {
              if (res) {
                this.beEndDt = true;
                this.$set(this.formItem, "lvEndDt", res.lvEndDt);
                this.$set(this.formItem, "lvDays", res.lvDays);
              } else {
                this.beEndDt = false;
              }
            });
          }
        });
      }
    },
    EndDateChange() {
      if (
        this.formItem.lvType &&
        this.formItem.lvEndDt &&
        this.formItem.lvType != "P01" &&
        this.formItem.lvType != "P02"
      ) {
        this.$set(this.formItem, "lvEndTm", "17:30");
      }
    },
    getDateChange() {
      // 婚假M
      if (this.formItem.lvType == "M") {
        if (this.formItem.lvBeginDt) {
          this.$set(
            this.formItem,
            "lvEndDt",
            this.getNextDate(this.formItem.lvBeginDt, 9)
          );
          this.$set(this.formItem, "lvEndTm", "17:30");
        }
      }
    },

    submitt() {
      this.$refs["formItem"].validate(valid => {
        if (valid) {
          this.formItem.lvBeginDt = this.formItem.lvBeginDt
            ? this.date.dateVal(this.formItem.lvBeginDt, "YYYY-MM-DD")
            : null;
          this.formItem.lvEndDt = this.formItem.lvEndDt
            ? this.date.dateVal(this.formItem.lvEndDt, "YYYY-MM-DD")
            : null;
          if (this.formItem.lvBeginDt > this.formItem.lvEndDt) {
            this.$Message.error("休假结束时间不得小于休假开始时间！");
            return;
          } else if (this.formItem.lvBeginDt == this.formItem.lvEndDt) {
            if (
              new Date(
                this.formItem.lvBeginDt + " " + this.formItem.lvBeginTm
              ) > new Date(this.formItem.lvEndDt + " " + this.formItem.lvEndTm)
            ) {
              this.$Message.error("休假结束时间不得小于休假开始时间！");
              return;
            }
          }
          this.$Modal.confirm({
            title:
              this.lang == "zh"
                ? this.chName.suresubmit
                : this.enName.suresubmit,
            content: "",
            okText:
              this.lang == "zh" ? this.chName.confirm : this.enName.confirm,
            cancelText:
              this.lang == "zh" ? this.chName.cancel : this.enName.cancel,
            onOk: () => {
              this.handle();
            },
            onCancel: () => {}
          });
        }
      });
    },
    handle() {
      let obj = JSON.parse(JSON.stringify(this.formItem));
      obj = this.toLine(obj);
      let lvBeginTm = new Date(
          this.formItem.lvBeginDt + " " + this.formItem.lvBeginTm
        ),
        lvEndTm = new Date(this.formItem.lvEndDt + " " + this.formItem.lvEndTm);
      let objData1 = {
        ...this.formItem,
        lvBeginTm: lvBeginTm,
        lvEndTm: lvEndTm,
        applySerialnumber: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .serialnumber
      };
      axios.post("/applyLeave/leaveApplyCheck", objData1).then(res1 => {
        if (res1) {
          let arr = [
            {
              objData1: {
                ...obj,
                agent_apply_user_id: this.formItem.applyUserId,
                agent_apply_serialnumber: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).serialnumber,
                apply_serialnumber: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).serialnumber,
                agent_apply_name: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).userName,
                // agent_apply_position: this.formItem.applyPosition,
                agent_apply_position_name: this.formItem.applyPosition,
                be_agent: 0
              },
              stringData1: "LV01",
              type: "B31"
            }
          ];
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            if (res) {
              this.$Message.info(this.$t("sbumit_Success"));
              this.$router.push(
                "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
              );
            }
            this.spinShow = false;
          });
        }
      });
    },
    toLine(name) {
      let arr = Object.keys(name);
      let arr1 = Object.values(name);
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].replace(/([A-Z])/g, "_$1").toLowerCase()] = arr1[i];
      }
      return obj;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  height: 38px;
  line-height: 38px;
  padding-left: 0px !important;
  color: #666;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid transparent;
  transition: all 0.2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/LeaveApplicationApply.vue